import React from 'react';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import ButtonComp from '../Button/buttonComp';
import Strings from '../../constants/stringConstant';
import {ReactComponent as CloseIcon} from '../../assets/images/closeIcon.svg';
import {CircularProgress} from '@mui/material';
import failAnimation from '../../assets/json/failure.json';
import Lottie from 'lottie-react';
const ModalwithButton = ({
  open,
  onClose,
  message,
  subMessage,
  onClickButton,
  value,
  cancelBtn = false,
  children,
  buttonDisable,
  loading,
  ImageDisplay,
  cancelValue = Strings.cancel,
  height,
  minWidth,
  maxWidth,
  width,
  boxheight,
  topCloseButton = null,
  leftRenderWithoutPadding = false,
  bolderHeadings = false,
  subMessageColor = null,
  rejectedLottie = false,
  paddingMessage,
}) => {
  return (
    <Dialog
      onClick={event => event.stopPropagation()}
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          width: width,
          borderRadius: '12px',
          minWidth: minWidth || '328px',
          maxWidth: maxWidth || '378px',
          height: height,
          opacity: '0px',
        },
      }}>
      {rejectedLottie && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#FAFAFA',
            paddingTop: '24px',
          }}>
          <Lottie
            animationData={failAnimation}
            loop={false}
            style={{height: '94px', width: '153px'}}
          />
        </Box>
      )}

      <Box
        sx={{
          padding: '24px',
          borderRadius: '12px',
          width: '100%',
          height: boxheight,
          background: '#FAFAFA',
          maxHeight: '80vh',
          overflowY: 'auto',
        }}>
        {(message || subMessage) && (
          <Box
            textAlign="center"
            sx={{paddingBottom: paddingMessage || '16px'}}>
            {ImageDisplay && <ImageDisplay />}
            <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
              <Box
                className={
                  bolderHeadings ? 'semitext-bold-18px' : 'text-medium-18px'
                }
                marginBottom={leftRenderWithoutPadding ? 0 : 2}
                sx={{
                  color: '#322E56',
                  textAlign:
                    topCloseButton || leftRenderWithoutPadding
                      ? 'left'
                      : 'center',
                  width: '100%',
                }}>
                {message}
              </Box>
              {topCloseButton && (
                <CloseIcon
                  onClick={topCloseButton}
                  style={{cursor: 'pointer'}}
                />
              )}
            </Box>
            <Box
              className="text-400-14px"
              sx={{
                color: subMessageColor ?? '#322E56',
                textAlign: leftRenderWithoutPadding ? 'left' : 'center',
              }}>
              {subMessage}
            </Box>
          </Box>
        )}
        {children && children}

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            justifyContent: 'center',
          }}>
          {value && (
            <ButtonComp
              type="submit"
              className="text-bold-16px"
              value={
                loading ? <CircularProgress color="white" size={24} /> : value
              }
              gradient="linear-gradient(168deg, #F37021 -13.5%, #FDBA12 119.9%)"
              height="48px"
              width="100%"
              padding="14px 24px"
              textcolor="#fff"
              borderRadius="8px"
              alignItems="center"
              onClick={onClickButton}
              disabled={loading ? loading : buttonDisable}
            />
          )}
          {cancelBtn && (
            <ButtonComp
              className="text-bold-16px"
              variant={'none'}
              textcolor={'#F37021'}
              value={cancelValue}
              onClick={onClose}
            />
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

ModalwithButton.propTypes = {
  cancelBtn: PropTypes.bool,
  message: PropTypes.string,
  onClickButton: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  subMessage: PropTypes.string,
  value: PropTypes.any,
  children: PropTypes.node,
  buttonDisable: PropTypes.bool,
  loading: PropTypes.bool,
  ImageDisplay: PropTypes.elementType,
  cancelValue: PropTypes.string,
  height: PropTypes.string,
  minWidth: PropTypes.string,
  width: PropTypes.string,
  boxheight: PropTypes.string,
  topCloseButton: PropTypes.func,
  leftRenderWithoutPadding: PropTypes.bool,
  bolderHeadings: PropTypes.bool,
  subMessageColor: PropTypes.string,
  maxWidth: PropTypes.any,
  rejectedLottie: PropTypes.any,
  paddingMessage: PropTypes.any,
};

export default ModalwithButton;
